import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getContacts } from '../../services/api';
import { ArrowLeft, Mail } from 'lucide-react';

const ContactSubmissions = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContacts();
  }, []);

  const fetchContacts = async () => {
    try {
      const data = await getContacts();
      setContacts(data);
    } catch (error) {
      console.error('Error fetching contacts:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-gray-600">Loading...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-5xl mx-auto px-6 py-6">
          <Link
            to="/admin/dashboard"
            className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-4"
          >
            <ArrowLeft size={16} />
            Back to Dashboard
          </Link>
          <h1 className="text-2xl font-serif text-gray-900">Contact Submissions</h1>
        </div>
      </header>

      <div className="max-w-5xl mx-auto px-6 py-12">
        {contacts.length === 0 ? (
          <div className="bg-white border border-gray-200 p-12 text-center">
            <Mail size={48} className="mx-auto text-gray-400 mb-4" />
            <p className="text-gray-600">No contact submissions yet.</p>
          </div>
        ) : (
          <div className="space-y-4">
            {contacts.map((contact) => (
              <div key={contact.id} className="bg-white border border-gray-200 p-6">
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h3 className="text-lg font-serif text-gray-900 mb-1">{contact.name}</h3>
                    <a
                      href={`mailto:${contact.email}`}
                      className="text-sm text-gray-600 hover:text-gray-900"
                    >
                      {contact.email}
                    </a>
                  </div>
                  <span className="text-xs text-gray-500">
                    {new Date(contact.submittedAt).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </span>
                </div>
                <div className="pt-4 border-t border-gray-200">
                  <p className="text-gray-700 whitespace-pre-wrap">{contact.message}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactSubmissions;